export default "__VITE_ASSET__4jJjSvYz__"